export enum WeightUnits {
  Metric,
  Imperial,
}
